// extracted by mini-css-extract-plugin
export default {"main":"Title_main__+nyfh","title":"Title_title__oAdpf"};